import { render, staticRenderFns } from "./RevenueShareDetail.vue?vue&type=template&id=44de8be2&scoped=true&"
import script from "./RevenueShareDetail.vue?vue&type=script&lang=js&"
export * from "./RevenueShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./RevenueShareDetail.vue?vue&type=style&index=0&id=44de8be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44de8be2",
  null
  
)

export default component.exports